import { DownloadGeoJsonButton } from "@/components/Attributes/DownloadGeoJsonButton";
import { OpenMapButton } from "@/components/Attributes/OpenMapButton";
import { ViewMapButton } from "@/components/ViewMapButton";
import * as Config from "@/config";
import { useMapDrawing } from "@/stores/mapDrawing";
import * as Common from "@/utils/common";
import React, { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";

interface MapInputContainerProps {
  isType: Config.Data;
  attributes: Array<any>;
  chooseComponent?: (attr: any, isType: Config.Data) => React.ReactNode;
}

export const MapInputContainer: React.FC<MapInputContainerProps> = ({
  isType,
  attributes,
  chooseComponent,
}) => {
  const filteredAttr = attributes.filter((attr) => Common.isMapDrawing(attr));
  return (
    <>
      {filteredAttr.map((attribute) => {
        return (
          <MapInputRow
            key={attribute.id || attribute.name}
            isType={isType}
            attr={attribute}
            chooseComponent={chooseComponent}
          />
        );
      })}
    </>
  );
};

export const MapInputRow = ({
  isType,
  attr,
  chooseComponent,
}: {
  isType: Config.Data;
  attr: any;
  chooseComponent?: (attr: any, isType: Config.Data) => React.ReactNode;
}) => {
  const { getValues, setValue, control } = useFormContext();
  const { p_id } = useMapDrawing();

  const attrValue = getValues(`attributes.${attr.id}`) || "";
  const required = attr?.attribute_setting_values.find(
    (setting: any) =>
      setting.attribute_setting_code === Config.ATTRIBUTE_SETTING_IS_REQUIRED
  );
  const isMapButton = Common.isMapButtonActive(attr);
  const isRequestedLocation =
    attr.column_name === Config.ATTRIBUTE_COLUMN_NAME.requestedLocation;
  const isMapDrawing = Common.isMapDrawing(attr);
  const isPId = Common.isPId(attr);
  const isOtherItem = Common.OtherAttributes.isOtherItem(attr);

  const otherItemParentAttributeId =
    Common.OtherAttributes.getOtherItemParentAttributeId(attr);
  const selectedOtherItemParentValue = useWatch({
    control,
    name: `attributes.${otherItemParentAttributeId}`,
  });

  useEffect(() => {
    if (isPId) {
      setValue(`attributes.${attr.id}`, p_id);
    }
  }, [p_id]);

  useEffect(() => {
    if (!Common.OtherAttributes.showOtherItem(selectedOtherItemParentValue)) {
      setValue(`attributes.${attr.id}`, "");
    }
  }, [selectedOtherItemParentValue]);

  if (
    isOtherItem &&
    !Common.OtherAttributes.showOtherItem(selectedOtherItemParentValue)
  ) {
    return null;
  }

  return (
    <div className="map-input-section">
      <div
        className={`width-full ${
          (isMapButton || isMapDrawing) && "map-button-active"
        }`}
      >
        <div className="map-input-cell uk-position-relative height-80">
          {attr.name}
          {required && <span className="error">※</span>}
          {isMapButton && !isMapDrawing && (
            <OpenMapButton attribute={attr} attrValue={attrValue} />
          )}
          {isRequestedLocation && <DownloadGeoJsonButton />}
          {isMapDrawing && <ViewMapButton attribute={attr} />}
        </div>
      </div>
      <div className={`grow width-full flex-col ${isMapDrawing && ""}`}>
        {chooseComponent?.(attr, isType)}
      </div>
    </div>
  );
};
